import type { FC } from 'react';

// utils

// components
import Dialog from '@components/Dialog/Dialog';
import { faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { EmailSignatureFieldTypes } from '../consts';
import styles from './EmailSignatureErrorUploadingImagesDialog.module.scss';

type EmailSignatureErrorUploadingImagesDialogProps = {
  showErrorDialog: boolean;
  closeDialog: () => void;
};

/**
 * If one of the images failed to upload, we will display a error message to warn the users based on the type of field
 * of that image
 * @param emailSignatureFieldTypes The type of the field of the image failed to upload
 */
export function getErrorUploadingMessage(
  emailSignatureFieldTypes: EmailSignatureFieldTypes | undefined | null,
): string {
  switch (emailSignatureFieldTypes) {
    case EmailSignatureFieldTypes.IMAGE:
      return 'One of your images has failed to upload properly, please try again later';
    case EmailSignatureFieldTypes.SOCIAL:
      return 'One of your social icons images has failed to upload properly, please try again later';
    case EmailSignatureFieldTypes.CONTACT:
      return 'One of your details icons images has failed to upload properly, please try again later';
    default:
      return 'There is an error while saving your signature, please try again later';
  }
}

const EmailSignatureErrorUploadingImagesDialog: FC<
  React.PropsWithChildren<EmailSignatureErrorUploadingImagesDialogProps>
> = ({ showErrorDialog, closeDialog, children }) => {
  return (
    <Dialog show={showErrorDialog} onClose={closeDialog} ariaLabel="Email signature error">
      <div className={styles['error-email-signature-warning']}>
        <div className={styles['notification-icon']}>
          <FontAwesomeIcon icon={faExclamationCircle} />
        </div>
        <h3 className={styles['error-email-signature-warning-heading']}>Something went wrong!</h3>
        <p className={styles['error-email-signature-warning-explainer']}>{children}</p>
      </div>
    </Dialog>
  );
};

export default EmailSignatureErrorUploadingImagesDialog;
